// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';
import { AppRewardConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/AppReward';

const useBridgeAppRewardConfigurations: () => UseQueryResult<
  TemplateContract<AppRewardConfiguration>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryBridgeAppRewardConfigurations', offset, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryAppRewardConfigurations(offset!);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useBridgeAppRewardConfigurations;
